import { useRouter } from 'next/router';
import { GetStaticPaths, GetStaticProps } from 'next';

// Components
import Button from 'epn-ui/umd/dist/components/Button';
import MarkingForm from '@components/pages/tools/marking/marking';

import ErrorPage from 'src/pages/404';

import apiHooks from '@apiHooks';

// HOCs
import WithRole, { rolesEnum } from '@HOCs/WithRole';

import useI18n, { getLocalePaths } from '@i18n';

import routes from '@config/routes.json';

import { IGetUserProfileDataFormatted } from '@api/types';

const { useUserProfile } = apiHooks;

const MarkingPage: React.FC = () => {
    const { data: userData, isLoading } = useUserProfile<IGetUserProfileDataFormatted>();
    const router = useRouter();
    const { t, locale } = useI18n();

    const handleTrafficSource = () => {
        router.push({
            pathname: `/[locale]${routes.placements.add}`,
            query: { locale },
        });
    };

    if (!isLoading) {
        if (!userData?.wmOnboarding?.hasAllowedPlacement) {
            return (
                <div className="px-4 py-8 text-center bg-blueGray-100 mb-36">
                    <p className="text-blueGray-600 text-p1">
                        {t(
                            'Please note that an approved traffic sources is required to fill out the data',
                        )}
                    </p>
                    <Button className="mt-6" type="primary" onClick={handleTrafficSource}>
                        {t('Add traffic source')}
                    </Button>
                </div>
            );
        }
    }

    return <MarkingForm />;
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
    return { props: { locale: params?.locale } };
};

export const getStaticPaths: GetStaticPaths = async () => {
    return { paths: getLocalePaths(), fallback: false };
};

// TODO убрать костыль
export default WithRole(
    {
        epn: MarkingPage,
        epncpa: ErrorPage,
    }[process.env.NEXT_PUBLIC_PROJECT_NAME],
    [rolesEnum.user],
);
